import type { McpScope } from '@amitable/shared/mcp-contract'
import { env } from '@/env'
import { resolveApiUrl } from '@/shared/lib/api-url'

export type AuthorizationRequest = {
  account: { id: string; name: string; username: string }
  app: {
    clientId: string
    name: string
    uri: string | null
    metadataUrl: string | null
    verified: false
  }
  permissions: Array<McpScope>
  workspaces: Array<{ id: string; name: string }>
  fixedWorkspaceId: string | null
  invalidationPending: boolean
}

export class AuthorizationLoginRequired extends Error {}

export async function requestAuthorization<T>(
  path: 'request' | 'decision',
  body: Record<string, unknown>,
  signal?: AbortSignal,
): Promise<T> {
  const response = await fetch(
    resolveApiUrl(env.VITE_API_URL, `/mcp/oauth/${path}`),
    {
      method: 'POST',
      credentials: 'include',
      signal,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  )
  if (response.status === 401) throw new AuthorizationLoginRequired()
  if (!response.ok)
    throw new Error(
      'Authorization could not complete. Restart the connection from the app.',
    )

  return response.json() as Promise<T>
}
